export default __webpack_public_path__ + "static/media/mesh-white.8a93caba.jpg";